var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-1" },
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("e-store-combo", {
                    attrs: {
                      id: "cost-contract-supplier-filter-store",
                      required: false,
                      "only-active-options": true,
                    },
                    model: {
                      value: _vm.filters.storeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "storeId", $$v)
                      },
                      expression: "filters.storeId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("e-search-sku", {
                    attrs: {
                      id: "cost-contract-supplier-filter-sku",
                      required: false,
                      "only-active": true,
                      "include-fixed-assets": true,
                    },
                    model: {
                      value: _vm.filters.skuId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "skuId", $$v)
                      },
                      expression: "filters.skuId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.filterData },
        },
        [
          _c("b-table", {
            ref: "cost-contract-supplier-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("COST_CONTRACT_SUPPLIER.NAME"),
                "male",
                _vm.queryExecuted
              ),
              fields: _vm.fields,
              items: _vm.sortedContracts,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(storeId)",
                fn: function (row) {
                  return [
                    !row.item.storeId
                      ? _c(
                          "b-badge",
                          { attrs: { variant: "light-secondary" } },
                          [_vm._v(" " + _vm._s(_vm.$t("Geral")) + " ")]
                        )
                      : _c("span", [
                          _vm._v(_vm._s(_vm.getStoreName(row.item.storeId))),
                        ]),
                  ]
                },
              },
              {
                key: "cell(skuId)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(row.item.skuId) +
                        _vm._s(
                          row.item.skuName ? " - " + row.item.skuName : ""
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(costValue)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("currency")(row.item.costValue)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(validFrom)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("datetime")(row.item.validFrom)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(validTo)",
                fn: function (row) {
                  return [
                    row.item.validTo
                      ? _c("span", [
                          _vm._v(_vm._s(_vm._f("datetime")(row.item.validTo))),
                        ])
                      : _c(
                          "b-badge",
                          { attrs: { variant: "light-secondary" } },
                          [_vm._v(" " + _vm._s(_vm.$t("sem limite")) + " ")]
                        ),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "show-update": _vm.$can(
                          "Update",
                          "SkuCostContractSupplier"
                        ),
                        "show-delete": _vm.$can(
                          "Delete",
                          "SkuCostContractSupplier"
                        ),
                      },
                      on: {
                        update: function ($event) {
                          return _vm.showUpdateSidebar(row)
                        },
                        delete: function ($event) {
                          return _vm.deleteContractLocal(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("cost-contract-supplier-sidebar", {
        ref: "cost_contract_supplier_sidebar",
        on: { save: _vm.getData },
      }),
      _vm.$can("Create", "SkuCostContractSupplier")
        ? _c("fab", {
            attrs: { "main-tooltip": _vm.$t("Adicionar Custo Contratado") },
            on: { click: _vm.showCreateSidebar },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }